module.exports = __webpack_public_path__ + "static/media/fuzznimp_logo.1d4a2d48.png";